import SingleAssetWithButton from './SingleAssetWithButton';

export default SingleAssetWithButton;